import React from 'react';
import { connect } from 'react-redux';
import { Link, Text } from '@beef/ui-kit';
import { useIsMobileDimension } from '@beef/ui-kit/hooks';
import classNames from 'classnames/bind';
import { cutTitleBlock } from "../../../utils";
import { getHeadingTitle } from "../../../../store/blocks/heading/selectors";
import { getTariffsHref, getTariffsTextLink, getTariffsTitle } from "../../../../store/blocks/tariffs/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _TariffsBlockHeading = function _TariffsBlockHeading(_ref) {
  var title = _ref.title,
    href = _ref.href,
    textLink = _ref.textLink,
    _ref$headingTag = _ref.headingTag,
    headingTag = _ref$headingTag === void 0 ? 'h2' : _ref$headingTag,
    size = _ref.size;
  var isMobile = useIsMobileDimension();
  var adaptiveTitle = cutTitleBlock(isMobile, title);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('header'),
    "data-t-id": "components-TariffsBlockHeading"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('header__title')
  }, adaptiveTitle && /*#__PURE__*/React.createElement(Text, {
    size: size,
    tagType: headingTag
  }, adaptiveTitle)), textLink && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    href: href,
    isNoUnderline: true,
    size: "size4-m",
    target: "_blank"
  }, textLink)));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    size: getHeadingTitle(state) ? 'size1-m' : 'size0-b',
    title: getTariffsTitle(state),
    href: getTariffsHref(state),
    textLink: getTariffsTextLink(state)
  };
};
export var TariffsBlockHeading = connect(mapStateToProps)(_TariffsBlockHeading);